import type { DesignerThemeCore } from "../DesignerTheme.ts";

export const themeCore: Pick<
  DesignerThemeCore,
  "borderRadius" | "fontFamily" | "fontSize" | "fontSizeSmall" | "fontSizeLarge"
> = {
  borderRadius: 4,

  fontFamily: "'Inter', sans-serif",
  fontSize: "12px",
  fontSizeSmall: "11px",
  fontSizeLarge: "14px",
};
